import { render, staticRenderFns } from "./DataDown.vue?vue&type=template&id=2a47de36&scoped=true"
import script from "./DataDown.vue?vue&type=script&setup=true&lang=js"
export * from "./DataDown.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DataDown.vue?vue&type=style&index=0&id=2a47de36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_dshyztwqotzq6hkhxg56wcmkza/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a47de36",
  null
  
)

export default component.exports